import { I as Icons, d as defineCustomElement$1 } from './p-3a198e00.js';
const OwcIcon = Icons;
const defineCustomElement = defineCustomElement$1;
export { OwcIcon, defineCustomElement };